export default __webpack_public_path__ + "static/media/featured.363619f3.svg";